import 'react';
import Overlay from '@lendi-ui/overlay';
import Transition, { mixin } from '@lendi-ui/transition';
import styled, { css } from 'styled-components';
import { normalise } from '@lendi-ui/utils';
import { depth } from '@lendi-ui/depth';
import { bg, color } from '@lendi-ui/color';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var SIDEBAR_ZINDEX = 999;
var MINIMUM_GUTTER_WIDTH = '3rem';

var Wrapper = styled.div.withConfig({
  displayName: "indexstyle__Wrapper",
  componentId: "lui__sc-1oc64o8-0"
})(["", " display:flex;flex-direction:column;position:fixed;bottom:0;width:calc(100% - ", ");max-width:22.5rem;overflow:hidden;transition:transform 0.25s;z-index:", ";", " ", ";", " ", ";"], normalise, MINIMUM_GUTTER_WIDTH, SIDEBAR_ZINDEX, bg('shade.0'), depth(1), _ref => {
  var {
    side,
    top
  } = _ref;

  if (side === 'left') {
    return css(["left:0;top:", "px;transform:translateX(-100%);"], top);
  } else {
    return css(["right:0;top:", "px;transform:translateX(100%);"], top);
  }
}, _ref2 => {
  var {
    side,
    transition
  } = _ref2;

  if (side === 'left') {
    return mixin(transition, {
      entering: {
        transform: 'translateX(0)'
      },
      entered: {
        transform: 'translateX(0)'
      },
      exit: {
        transform: 'translateX(0)'
      },
      exiting: {
        transform: 'translateX(-100%)'
      }
    });
  } else {
    return mixin(transition, {
      entering: {
        transform: 'translateX(0)'
      },
      entered: {
        transform: 'translateX(0)'
      },
      exit: {
        transform: 'translateX(0)'
      },
      exiting: {
        transform: 'translateX(100%)'
      }
    });
  }
});
var SidebarContent = styled.div.withConfig({
  displayName: "indexstyle__SidebarContent",
  componentId: "lui__sc-1oc64o8-1"
})(["width:100%;overflow-y:scroll;flex:1;"]);
var SidebarFooter = styled.div.withConfig({
  displayName: "indexstyle__SidebarFooter",
  componentId: "lui__sc-1oc64o8-2"
})(["width:100%;align-self:flex-end;", ""], _ref3 => {
  var {
    hasTopShadow
  } = _ref3;

  if (hasTopShadow) {
    return css(["flex-shrink:0;border-top:1px solid ", ";", ";"], color('shade.100'), depth(4));
  }

  return undefined;
});

var _excluded = ["children", "direction", "top", "isVisible", "onHide", "overlayZIndex", "className"];

var Sidebar = _ref => {
  var {
    children: _children,
    direction = 'left',
    top = 0,
    isVisible = false,
    onHide,
    overlayZIndex = 2,
    // We just default this value to 2 right now in order to keep consistensy with NavbarBase and update it once LUI z-index management completed.
    className
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(Overlay, {
      isVisible: isVisible,
      zIndex: overlayZIndex,
      onHide: onHide
    }), /*#__PURE__*/jsx(Transition, {
      isActive: isVisible,
      timeout: 250,
      children: state => /*#__PURE__*/jsx(Wrapper, _objectSpread2(_objectSpread2({
        side: direction,
        transition: state,
        top: top,
        className: className
      }, otherProps), {}, {
        children: _children
      }))
    })]
  });
};

Sidebar.Content = _ref2 => {
  var {
    children
  } = _ref2;
  return /*#__PURE__*/jsx(SidebarContent, {
    children: children
  });
};

Sidebar.Footer = _ref3 => {
  var {
    children,
    hasTopShadow = false
  } = _ref3;
  return /*#__PURE__*/jsx(SidebarFooter, {
    hasTopShadow: hasTopShadow,
    children: children
  });
};

export { Sidebar, Sidebar as default };
